// extracted by mini-css-extract-plugin
export default {"headerapp":"Header_headerapp__R9PBS","user":"Header_user__7zWs4","image1":"Header_image1__jOuq6","image2":"Header_image2__nK8Np"};